import React from "react";
import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

export type CustomColor = "primary" | "secondary" | "success" | "error";

type ColorStyles = {
  backgroundColor: string;
  color: string;
};

const customColors: Record<CustomColor, ColorStyles> = {
  secondary: {
    backgroundColor: "#EDEDED",
    color: "text.secondary",
  },
  primary: {
    backgroundColor: "#E5F6FD",
    color: "#18363E",
  },
  success: {
    backgroundColor: "#E8F5E9",
    color: "success.dark",
  },
  error: {
    backgroundColor: "#FDECEA",
    color: "#5F2120",
  },
} as const;

interface StatusAlertProps {
  message: string;
  color?: CustomColor;
}

export const StatusAlert = ({
  message,
  color = "primary",
}: StatusAlertProps): React.JSX.Element => {
  const styles = customColors[color];

  return (
    <Box
      sx={{
        px: 1,
        py: 0.5,
        borderRadius: 1,
        backgroundColor: styles.backgroundColor,
        color: styles.color,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Typography variant="caption" color="inherit">
        {message}
      </Typography>
    </Box>
  );
};
